const state = {
  language: localStorage.getItem("lang") || "zh-CN",
};

const mutations = {
  SET_LANGUAGE: (state, lang) => {
    state.language = lang;
    localStorage.setItem("lang", lang);
  },
};

const actions = {
  setLanguage({ commit }, lang) {
    commit("SET_LANGUAGE", lang);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
